<template>
  <form @submit.prevent="$emit('submit')" class="white-box p30">
    <div class="row">
      <div class="col-sm-6">
        <FieldTextInput name="Report Name" rules="required" v-model="value.name" :disabled="disabled" />
      </div>
      <div class="col-sm-6">
        <FieldTextInput name="Link" rules="required|url" type="url" v-model="value.link" :disabled="disabled" />
      </div>
      <div class="col-sm-6">
        <FieldRadio name="Category" rules="required" v-model="value.category" :options="categories" colClass="col-sm-4"
          :disabled="disabled" />
      </div>
    </div>
    <div class="d-flex justify-content-center">
      <button v-if="$route.name !== 'AddReport'" v-permissions="'Delete Report'" @click="$emit('on-delete')" class="btn btn-border-red mx-2"
        type="button">Delete</button>
      <button v-permissions="'Create Report,Edit Report'" v-if="!disabled" class="btn btn-orange" type="submit">Save</button>
    </div>
  </form>
</template>
<script>
import axios from '@/axios';
import FieldTextInput from '@/components/field/TextInput.vue'
import FieldRadio from '@/components/field/Radio.vue'
import { showErrorMessage } from '@/utils';

export default {
  components: {
    FieldTextInput,
    FieldRadio
  },
  props: ['value', 'disabled'],
  data() {
    return {
      categories: []
    }
  },
  async mounted() {
    try {
      this.$store.dispatch('toggleLoadingProgress', true)
      const res = await axios.get(`/report-categories`)
      this.categories = res?.data?.data?.map(category => ({
        text: category, value: category
      })) ?? []
    } catch (err) {
      showErrorMessage(err)
    } finally {
      this.$store.dispatch('toggleLoadingProgress', false)
    }
  }
}
</script>
